import State from 'interfaces/state/State';

export const isLoading$ = (state: State): boolean => state.confirm.isLoading;
export const isError$ = (state: State): boolean => state.confirm.isError;
export const token$ = (state: State) => state.confirm.token;
export const email$ = (state: State) => state.confirm.email;
export const isConfirmed$ = (state: State) => state.confirm.isConfirmed;
